import { ArrowBack, Close } from '@mui/icons-material'
import { AppBar, createTheme, IconButton, ThemeProvider, Toolbar, Typography } from '@mui/material'
import TrashCan from 'assets/icons/TrashCan'
import cn from 'classnames'
import colors from 'colors'
import { Box, Divider } from 'components/Material/index'
import { styled } from 'styled-components'
import useTextStyles from 'styles/useTextStyles'

const CustomizedAppBar = styled(AppBar)`
  box-shadow: inherit;
  position: sticky;
  /* border-bottom: solid 1px ${() => colors['gray-cac']};
  border-left: solid 1px ${() => colors['gray-cac']}; */
`

type SidebarHeaderProps = {
  onClick?: () => void
  hideCloseButton?: boolean
  title: string
  leftArrowClick?: () => void
  trashIcon?: () => void
  isBlue?: boolean
}

export const SidebarHeader = ({
  onClick,
  leftArrowClick,
  title,
  hideCloseButton = false,
  trashIcon,
  isBlue
}: SidebarHeaderProps) => {
  const theme = createTheme({
    palette: {
      primary: {
        main: isBlue ? colors['blue-bb'] : colors['white-bb']
      }
    }
  })
  return (
    <ThemeProvider theme={theme}>
      <CustomizedAppBar
        position="relative"
        className={cn('pr-3 w-full  items-center shadow-inherit  ', {
          'pl-1': leftArrowClick,
          'pl-6': !leftArrowClick
        })}
      >
        <Toolbar className={cn('p-0 flex flex-nowrap justify-between w-full min-w-0 gap-2')}>
          <Box className="flex min-w-0 flex-1 flex-nowrap items-center gap-5">
            {leftArrowClick && (
              <IconButton
                aria-label="Back"
                className={cn('cursor-pointer shrink-0')}
                onClick={leftArrowClick}
                color="inherit"
                title="Voltar"
              >
                <ArrowBack className={cn({ 'text-blue-bb': !isBlue })} />
              </IconButton>
            )}
            <Box className="relative min-w-0 flex-1 self-stretch flex items-center">
              <Typography
                title={title}
                component="div"
                className="w-full"
                sx={{
                  ...useTextStyles.titleLarge,
                  color: isBlue ? colors['white-bb'] : colors['black-bb'],
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  '&:hover': {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    zIndex: 3,
                    backgroundColor: isBlue ? colors['blue-bb'] : colors['white-bb'],
                    whiteSpace: 'normal',
                    overflow: 'visible',
                    textOverflow: 'clip',
                    wordBreak: 'break-word'
                  }
                }}
              >
                {title}
              </Typography>
            </Box>
          </Box>
          {typeof trashIcon === 'function' && (
            <Box title="Excluir" onClick={trashIcon} className="shrink-0 text-blue-bb">
              <TrashCan colors={colors['blue-bb']} />
            </Box>
          )}

          {!hideCloseButton && (
            <IconButton
              title="Fechar"
              className="iconContainer shrink-0"
              onClick={onClick}
              color="inherit"
            >
              <Close className="text-blue-bb" />
            </IconButton>
          )}
        </Toolbar>
      </CustomizedAppBar>
      <Box>
        <Divider
          variant="fullWidth"
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            zIndex: 200
          }}
        />
      </Box>
    </ThemeProvider>
  )
}
